import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { AgreeOn } from 'src/app/models/agree-on';
import { MemberList } from 'src/app/models/member';
import { ZbResponseStatusCodes } from 'src/app/models/zb-response';
import { AuthService } from 'src/app/services/auth.service';
import { MainAppService } from 'src/app/services/main-app.service';
import * as XLSX from 'xlsx';
import { AgreeDialogComponent } from '../../agree-dialog/agree-dialog.component';
import { MemberDetailComponent } from '../member-detail/member-detail.component';

 

@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.css']
})
export class MemberListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  displayedColumns: string[] = ['memberId', 'name', 'lastName', 'countryCode', 'sex', 'age' ,'email', 'sourceDescription', 'dateTimeEntered', 'productsStartingPrice','productsFinalPrice', 'paymentAmount', 'delete'];
  dataSource :any =[];
  dateFrom = new Date( new Date().getFullYear(),  new Date().getMonth(), 1);
  dateUntil = new Date();
  isMemberTrash : boolean = false;

  members: Array<MemberList>
  exportName: string;

  constructor(
    public dialog: MatDialog,
    public mainAppService: MainAppService, 
    public auth: AuthService) {}

  ngOnInit(): void { 
    this.mainAppService.getAdminApp().subscribe(retval =>  {
        if (retval && retval.responseData){
          this.mainAppService.adminApp = retval.responseData;
        }
      });
  }

  search() {
    this.isMemberTrash = false;
    this.mainAppService.getMemberlist(this.dateFrom, this.dateUntil).subscribe(retval => 
      {
        if (retval && retval.responseData){
          this.members = retval.responseData;
          var dateFromString = moment( this.dateFrom).format('YYYYMMDD');
          var dateUntilString = moment( this.dateUntil).format('YYYYMMDD');
          this.exportName = dateFromString + "_" + dateUntilString +".xlsx";
          this.dataSource = new MatTableDataSource(retval.responseData)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  searchDeleted(){
    this.isMemberTrash = true;
    this.mainAppService.getMemberTrash(this.dateFrom, this.dateUntil).subscribe(retval => 
      {
        if (retval && retval.responseData){
          this.members = retval.responseData;
          var dateFromString = moment( this.dateFrom).format('YYYYMMDD');
          var dateUntilString = moment( this.dateUntil).format('YYYYMMDD');
          this.exportName = dateFromString + "_" + dateUntilString +".xlsx";
          this.dataSource = new MatTableDataSource(retval.responseData)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  export() {

    if (this.members && this.members.length > 0){
      this.exportAsExcelFile(this.members, this.exportName )
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(json);
    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, excelFileName); // initiate a file download in browser
  }

  showMember(member: MemberList){
    this.dialog.open(MemberDetailComponent, {
      width: '640px',
      height: '680px',
      data: member
    });
  }

  delete(member: MemberList){
    var agreeDto = new AgreeOn();
    agreeDto.title = "Yes Delete"
    agreeDto.text = "Delete Member, " + member.name + " " + member.lastName + "? Are you sure?"
    const dialogRef = this.dialog.open(AgreeDialogComponent, {
      width: '400px',
      data: agreeDto
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mainAppService.deleteMember(member.memberId).subscribe(retval => {
          if (retval && retval.statusCode == ZbResponseStatusCodes.OK ){
            this.search();
          }
        });
      }
    });
  }

  restoreMember(member: MemberList){
    var agreeDto = new AgreeOn();
    agreeDto.title = "Yes Restore"
    agreeDto.text = "Restore Member, " + member.name + " " + member.lastName + "? Are you sure?"
    const dialogRef = this.dialog.open(AgreeDialogComponent, {
      width: '400px',
      data: agreeDto
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mainAppService.restoreMember(member.memberId).subscribe(retval => {
          if (retval && retval.statusCode == ZbResponseStatusCodes.OK ){
            this.searchDeleted();
          }
        });
      }
    });
  }

  refreshData(){
    this.mainAppService.removeAllMainAppData().subscribe(retval => {
      if (retval && retval.statusCode == ZbResponseStatusCodes.OK ){
      }
    });
  }
}
